import React, { useState } from 'react';
import ImprovPlayer from './improvimania/PlayerScreen';
import GuessingPlayer from './guessing/PlayerScreen';
import TriviaPlayer from './trivia/PlayerScreen';
import LearnPlayer from './learn/PlayerScreen';
import AndScenePlayer from './andscene/PlayerScreen';
import WordMonsterPlayer from './wordmonster/PlayerScreen';
import ReactionPlayer from './reaction/PlayerScreen';
import SetTheBarPlayer from './setthebar/PlayerScreen';
import './Players.css';

const Players = ({
  socket,
  isEndGame,
  joinedSession,
  sessionId,
  setSessionId,
  playerName,
  setPlayerName,
  joinSession,
  gameStarted,
  setGameStarted,
  players,
  playerRole,
  isEndScene,
  currentLine,
  isSpeaker,
  nextLine,
  guessAdlibber,
  voteAdlibLine,
  sessionList,
  leaderboard,
  kicked,
  titleTheme,
  BackgroundMusic,
  speakingTheme,
  guessingTheme,
  sentGuess,
  game,
  joinError,
  isMusicMuted,
  setLeaderboard,
  serverType,
  setServerType,
  ipAddress,
  setIpAddress,
  switchServer,
  gameMode,
  activeVote,
  voteBudgetRemaining,
  votedLineIds,
}) => {
  const [noName, setNoName] = useState(false);

  const [inputSessionId, setInputSessionId] = useState('');

  const handleInputChange = (e) => {
    setInputSessionId(e.target.value);
  };

  const handleJoinById = () => {
    if (inputSessionId) {
      handleJoinClick(inputSessionId);
    }
  };
  
  const refreshSessions = () => {
    socket.emit('gimmeSessions'); 
  };

  const isCustomServer = serverType === 'custom';

  const handleSwitchServer = () => {
    switchServer(serverType, isCustomServer ? ipAddress : '');
  };

  const handleJoinClick = (sessionIds) => {
    if (!playerName) {
      setNoName(true);
    } else {
      joinSession(sessionIds);
    }
  };

  const renderImprovPlayerScreen = () => (
    <ImprovPlayer
      socket={socket}
      isEndGame={isEndGame}
      joinedSession={joinedSession}
      sessionId={sessionId}
      setSessionId={setSessionId}
      playerName={playerName}
      setPlayerName={setPlayerName}
      joinSession={joinSession}
      gameStarted={gameStarted}
      players={players}
      playerRole={playerRole}
      isEndScene={isEndScene}
      currentLine={currentLine}
      isSpeaker={isSpeaker}
      nextLine={nextLine}
      guessAdlibber={guessAdlibber}
      voteAdlibLine={voteAdlibLine}
      sessionList={sessionList}
      leaderboard={leaderboard}
      kicked={kicked}
      titleTheme={titleTheme}
      speakingTheme={speakingTheme}
      guessingTheme={guessingTheme}
      sentGuess={sentGuess}
      game={game}
      isMusicMuted={isMusicMuted}
      gameMode={gameMode}
      activeVote={activeVote}
      voteBudgetRemaining={voteBudgetRemaining}
      votedLineIds={votedLineIds}
    />
  );

  const renderGuessingPlayerScreen = () => (
    <GuessingPlayer
      socket={socket}
      isEndGame={isEndGame}
      joinedSession={joinedSession}
      sessionId={sessionId}
      setSessionId={setSessionId}
      playerName={playerName}
      setPlayerName={setPlayerName}
      joinSession={joinSession}
      gameStarted={gameStarted}
      setGameStarted={setGameStarted}
      players={players}
      playerRole={playerRole}
      isEndScene={isEndScene}
      currentLine={currentLine}
      isSpeaker={isSpeaker}
      nextLine={nextLine}
      guessAdlibber={guessAdlibber}
      sessionList={sessionList}
      leaderboard={leaderboard}
      kicked={kicked}
      titleTheme={titleTheme}
      speakingTheme={speakingTheme}
      guessingTheme={guessingTheme}
      sentGuess={sentGuess}
      game={game}
      isMusicMuted={isMusicMuted}
    />
  );

  const renderTriviaPlayerScreen = () => (
    <TriviaPlayer
      socket={socket}
      isEndGame={isEndGame}
      joinedSession={joinedSession}
      sessionId={sessionId}
      setSessionId={setSessionId}
      playerName={playerName}
      setPlayerName={setPlayerName}
      joinSession={joinSession}
      gameStarted={gameStarted}
      setGameStarted={setGameStarted}
      players={players}
      playerRole={playerRole}
      isEndScene={isEndScene}
      currentLine={currentLine}
      isSpeaker={isSpeaker}
      nextLine={nextLine}
      guessAdlibber={guessAdlibber}
      sessionList={sessionList}
      leaderboard={leaderboard}
      kicked={kicked}
      titleTheme={titleTheme}
      speakingTheme={speakingTheme}
      guessingTheme={guessingTheme}
      sentGuess={sentGuess}
      game={game}
      setLeaderboard={setLeaderboard}
    />
  );

  const renderLearnPlayerScreen = () => (
    <LearnPlayer
      socket={socket}
      isEndGame={isEndGame}
      joinedSession={joinedSession}
      sessionId={sessionId}
      setSessionId={setSessionId}
      playerName={playerName}
      setPlayerName={setPlayerName}
      joinSession={joinSession}
      gameStarted={gameStarted}
      setGameStarted={setGameStarted}
      players={players}
      playerRole={playerRole}
      isEndScene={isEndScene}
      currentLine={currentLine}
      isSpeaker={isSpeaker}
      nextLine={nextLine}
      guessAdlibber={guessAdlibber}
      sessionList={sessionList}
      leaderboard={leaderboard}
      kicked={kicked}
      titleTheme={titleTheme}
      speakingTheme={speakingTheme}
      guessingTheme={guessingTheme}
      sentGuess={sentGuess}
      game={game}
      setLeaderboard={setLeaderboard}
    />
  );


  const renderAndScenePlayerScreen = () => (
    <AndScenePlayer
      socket={socket}
      sessionId={sessionId}
      playerName={playerName}
      players={players}
      isMusicMuted={isMusicMuted}
    />
  );
  const renderWordMonsterPlayerScreen = () => (
    <WordMonsterPlayer
      socket={socket}
      sessionId={sessionId}
      playerName={playerName}
      isMusicMuted={isMusicMuted}
    />
  );
  const renderReactionPlayerScreen = () => (
    <ReactionPlayer
      socket={socket}
      sessionId={sessionId}
      playerName={playerName}
    />
  );
  const renderSetTheBarPlayerScreen = () => (
    <SetTheBarPlayer
      socket={socket}
      sessionId={sessionId}
      playerName={playerName}
      isMusicMuted={isMusicMuted}
    />
  );

  return (
    <div className="players-root">
      {!game ? (
        <>
          <div className="App players-join-shell">
            {sessionList.length > 0 && <h2>Join a Game</h2>}
            {sessionList.length > 0 && (
              <div>
                <input
                  className="players-input"
                  type="text"
                  value={playerName}
                  onChange={(e) => setPlayerName(e.target.value)}
                  placeholder="Enter Your Name"
                />
              </div>
            )}
            <div>
              {Array.isArray(sessionList) && sessionList.length > 0 ? (
                sessionList.length <= 4 ? (
                  <div className="players-session-grid">
                    {sessionList.map((sessionIds) => (
                      <button
                        className="players-session-button"
                        type="button"
                        key={sessionIds}
                        onClick={() => handleJoinClick(sessionIds)}
                      >
                        {sessionList.length === 1 ? (
                          "Join Session"
                        ) : (
                          <>
                            Join Session <br />
                            {sessionIds}
                          </>
                        )}
                      </button>
                    ))}
                  </div>
                ) : (
                  <div>
                    <input
                      className="players-input"
                      type="text"
                      value={inputSessionId}
                      onChange={handleInputChange}
                      placeholder="Enter session ID"
                    />
                    <button
                      className="players-session-button"
                      type="button"
                      onClick={handleJoinById}
                    >
                      Join Session
                    </button>
                  </div>
                )
              ) : (
                <div>
                <p>No active sessions available.</p>
                <div className="server-controls players-server-controls">
                  <div className="server-controls-label">Server</div>
                  <select
                    className="server-select"
                    value={serverType}
                    onChange={(e) => setServerType(e.target.value)}
                  >
                    <option value="fayaz.fly.dev">Production</option>
                    <option value="localhost">Dev</option>
                    <option value="custom">Local</option>
                  </select>

                  {isCustomServer && (
                    <input
                      className="server-input"
                      type="text"
                      value={ipAddress}
                      placeholder="Room code / IP"
                      onChange={(e) => setIpAddress(e.target.value)}
                    />
                  )}

                  <button
                    className="players-session-button players-refresh-button"
                    type="button"
                    onClick={handleSwitchServer}
                  >
                    Connect
                  </button>

                  <button
                    className="players-session-button players-refresh-button"
                    type="button"
                    onClick={refreshSessions}
                  >
                    Refresh
                  </button>
                </div>
              </div>
              )}
            </div>
            {noName && (
              <p className="players-error">
                First enter a name to join Session {sessionId}
              </p>
            )}
            {joinError && (
              <p className="players-error">
                {joinError}
              </p>
            )}
          </div>
        </>
      ) : game === 'improv' ? (
        renderImprovPlayerScreen()
      ) : (game === 'guessing' || game === 'guessing-gameshow' || game === 'guessing-spiral') ? (
        renderGuessingPlayerScreen()
    ) : game === 'trivia' ? (
      renderTriviaPlayerScreen()
    ): game === 'learn' ? (
        renderLearnPlayerScreen()
      ) : game === 'andscene' ? (
        renderAndScenePlayerScreen()
      ) : game === 'wordmonster' ? (
        renderWordMonsterPlayerScreen()
      ) : game === 'reaction' ? (
        renderReactionPlayerScreen()
      ) : game === 'setthebar' ? (
        renderSetTheBarPlayerScreen()
      ) :null}
    </div>
  );
};

export default Players;
